import { css } from "@emotion/react"
import { alpha } from "@mui/material"
import Theme from "appearance/Theme"

export class CartPageStyle {
  static FeaturedBoxStyle = css({
    backgroundColor: Theme.palette.primary.main,
    height: 200,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
  })

  static CartItemsContainerStyle = css({
    padding: Theme.spacing(8, 0),
  })

  static TotalTableContainerStyle = css({
    padding: Theme.spacing(2, 0),
  })
}
